import { Device, ProductType } from '../enum';
import { AdditionalPageOptions, CmsProductBenefit } from '../interface';

/**
 * Get CMS config from additionalPageOptions
 * @returns {object} - CMS config
 */
export const getCMSConfig = (): AdditionalPageOptions => window.additionalPageOptions!;

/**
 * Get all the ProductBenefit which belongs to this productType
 * @param {ProductType} productType - selected product type
 * @returns {CmsProductBenefit[]} - productBenefits
 */
export const getProductBenefits = (productType: ProductType): CmsProductBenefit[] => {
    return Object.values(getCMSConfig().productBenefits ?? {})
        .filter(benefit => Object.values(benefit.productType).includes(productType));
};

/**
 * Get all the DeviceBenefits text which belongs to this device
 * @param {Device} device - selected device
 * @returns {string[]} - deviceBenefits text
 */
export const getDeviceBenefits = (device: Device): string[] => {
    return Object.values(getCMSConfig().deviceBenefits ?? {})
        .filter(benefit => Object.values(benefit.deviceType).includes(device))
        .map(benefit => benefit.text);
};
